<mat-toolbar color="default">
	<mat-toolbar-row class="button-settings">
		<button mat-button *ngIf="sidenav" (click)="sidenav.toggle()">
			<mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
		</button>
		<button mat-icon-button color="warn" (click)="logOut()">
			<mat-icon matTooltip="Cerrar sesión">exit_to_app</mat-icon>
		</button>
	</mat-toolbar-row>
</mat-toolbar>